import React, { Fragment } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import ParticlesBg from 'particles-bg'
import {
  Grid,
  Typography,
  Card,
  Button,
  Hidden,
  Box,
  withStyles,
  withWidth,
  isWidthUp,
} from "@material-ui/core";
// import WaveBorder from "../../../shared/components/WaveBorder";
import ZoomImage from "../../../shared/components/ZoomImage";
// import { fontWeight } from "@material-ui/system";

const styles = (theme) => ({
  extraLargeButtonLabel: {
    fontSize: theme.typography.body1.fontSize,
    [theme.breakpoints.up("sm")]: {
      fontSize: theme.typography.h6.fontSize,
    },
  },
  extraLargeButton: {
    borderRadius: "100px",
    backgroundColor: "#361C10 !important",  // Your desired background
    "&:hover": {
  backgroundColor: "#4A2A1A !important" // Slightly lighter black on hover
},
    color: "#ffffff !important",           // Make text white
    fontFamily: "'Lato', 'sans-serif' !important",
    fontWeight: "850",
    textTransform: "none !important",
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.up("xs")]: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },

  titleText: {
    fontFamily: "'Playfair Display', serif !important",
    fontSize: "2.5rem !important", 
    fontWeight: "450", 
    lineHeight: "1.2",
  },
  noteText: {
    fontFamily: "'Lato', 'sans-serif' !important",
    fontSize: "1.2rem !important", 
    color: "#000000 !important",
    fontWeight: "450",
    lineHeight: "1.5",
  },


  card: {
    boxShadow: theme.shadows[4],
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("xs")]: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
    },
    [theme.breakpoints.up("sm")]: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    [theme.breakpoints.up("md")]: {
      paddingTop: theme.spacing(5.5),
      paddingBottom: theme.spacing(5.5),
      paddingLeft: theme.spacing(5),
      paddingRight: theme.spacing(5),
    },
    [theme.breakpoints.up("lg")]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(6),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6),
    },
    [theme.breakpoints.down("lg")]: {
      width: "auto",
    },
  },
  wrapper: {
    position: "relative",
    backgroundColor: "#FEF5E9",
    paddingBottom: theme.spacing(2),
  },
  image: {
    maxWidth: "100%",
    verticalAlign: "middle",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[4],
  },
  container: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(12),
    [theme.breakpoints.down("md")]: {
      marginBottom: theme.spacing(9),
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(6),
    },
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  containerFix: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "none !important",
    },
  },
  waveBorder: {
    paddingTop: theme.spacing(4),
  },
});

function HeadSection(props) {
  const { classes, theme, width } = props;
  return (
    <Fragment>
      <div className={classNames("lg-p-top", classes.wrapper)}>
        <div className={classNames("container-fluid", classes.container)}>
          <ParticlesBg
            type={theme.particle}
            bg={{ width: "100%", height: "100%", position: "absolute", zIndex: "0", top: 0, left: 0 }}
          />

          <Box display="flex" justifyContent="center" className="row">
            <Card
              className={classNames(classes.card, classes.transparentCard)}
              data-aos-delay="200"
              data-aos="zoom-in"
              square={true}
            >
              <div className={classNames(classes.containerFix, "container")}>
                <Box justifyContent="space-between" className="row">
                  <Grid item xs={12} md={5}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="space-between"
                      height="100%"
                    >
                      <Box mb={4}>
                        <Typography
                        className={classes.titleText}
                          variant={isWidthUp("lg", width) ? "h3" : "h4"}
                        >
                          At Wolfe, we are committed to ending global mental health challenges
                        </Typography>
                      </Box>
                      <div>
                        <Box mb={2}>
                          <Typography
                          className={classes.noteText}
                            variant={isWidthUp("lg", width) ? "h6" : "body1"}
                            color="textSecondary"
                          >
                           As the relentless rat race of life speeds on, mirroring the ever-changing paradigm shift in technology, there’s a diminishing regard for mental health as everyone scrambles just to put food on the table. Our mission is to step back and work tirelessly to end global mental health challenges by nurturing the minds of people through the use of generative AI.

                          </Typography>
                        </Box>
                        <Button
                          variant="contained"
                          fullWidth
                          className={classes.extraLargeButton} 
                          classes={{ label: classes.extraLargeButtonLabel }}
                          href="https://www.hellowolfe.ai" 
                        >
                          Say hello to Wolfe!
                        </Button>
                      </div>
                    </Box>
                  </Grid>
                  <Hidden smDown>
                    <Grid item md={6}>
                    <ZoomImage
                      src={`${process.env.PUBLIC_URL}/images/logged_out/major_wolfe_image.png`}
                      className={classes.image}
                      alt="Wolfe AI mental health companion logo with a howling wolf and moon"
                      style={{mixBlendMode: "multiply",borderRadius: "220px", maxWidth: "70%", height: "auto", display: "block", margin: "0 auto",  boxShadow: "none !important",border: "none !important"}}
                      />
                    </Grid>
                  </Hidden>
                </Box>
              </div>
            </Card>
          </Box>
        </div>
      </div>
  
    </Fragment>
  );
}

HeadSection.propTypes = {
  classes: PropTypes.object,
  width: PropTypes.string,
  theme: PropTypes.object,
};

export default withWidth()(
  withStyles(styles, { withTheme: true })(HeadSection)
);
